<!--
 * @Description: 内容管理页面
 * @Author: wuxuebing
 * @Date: 2024-07-10 11:58:56
 * @LastEditors: wuxuebing
 * @LastEditTime: 2024-07-24 15:57:52
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\topic-page\components\content-management.vue
-->
<template>
	<div class="tab-main">
		<nav class="tab-header">
			<ul>
				<li
					class="tab-header-item"
					v-for="(item, index) in tabArr"
					:key="'tab' + index"
					:class="{ 'active-item': activeTab === item.name }"
					@click="tabClick(item)"
				>
					{{ item.label }}
				</li>
			</ul>

			<div class="tools-btn">
				<el-button type="warning" size="mini" class="header-btn" v-show="!isEdit" @click="handlePreview">预览</el-button>

				<el-button type="primary" size="mini" class="header-btn btn-blue" @click="isEdit = !isEdit" v-show="!isEdit">修改</el-button>
				<el-button size="mini" class="header-btn" :disabled="!isEdit" :loading="btnLoading" @click="isEdit = !isEdit" v-show="isEdit"
					>取消</el-button
				>
				<el-button
					type="primary"
					size="mini"
					class="header-btn btn-blue"
					:disabled="!isEdit"
					:loading="btnLoading"
					@click="doSave"
					v-show="isEdit"
					>保存</el-button
				>
			</div>
		</nav>

		<section class="tab-content">
			<!-- 基本信息 -->
			<div class="tab-box" v-show="activeTab == 'baseInfo'">
				<!-- 顶部 upload -->
				<div class="top-upload">
					<div class="top-item">
						<div class="top-item-text is-required-item left-item">企业LOGO</div>
						<new-upload
							:aid="pageInfo.id"
							:acceptType="acceptArr"
							listType="picture-card"
							tableName="config_topic_page"
							assortment="HOME_LOGO"
							:isDisabled="!isEdit"
							:showTisp="false"
							:maxNum="1"
							width="100%"
							height="120px"
							ref="homeLogo"
							:uploadText="isEdit ? '上传图片' : '暂无资料'"
						></new-upload>
						<div class="mt5">
							支持图片格式：jpg/jpeg/png，建议上传尺寸：136*60px
						</div>
					</div>

					<div class="top-item">
						<div class="top-item-text">首页banner</div>
						<new-upload
							:aid="pageInfo.id"
							listType="picture-card"
							:acceptType="acceptArr"
							tableName="config_topic_page"
							assortment="HOME_BANNER"
							width="100%"
							height="120px"
							ref="homeBanner"
							:isDisabled="!isEdit"
							:maxNum="1"
							:uploadText="isEdit ? '上传图片' : '暂无资料'"
						></new-upload>
						<div class="mt5">
							支持图片格式：jpg/jpeg/png，建议上传尺寸：1920*360px
						</div>
					</div>
				</div>
				<!-- 表单 -->
				<el-form
					ref="baseForm"
					label-width="120px"
					:model="baseInfo"
					:rules="baseRules"
					:show-message="false"
					:label-position="formProps.labelPosition">
					<el-row :gutter="formProps.gutter">
						<el-col :span="9">
							<el-form-item label="公司名称" prop="homeIntro" required>
								<el-input v-model="baseInfo.homeIntro" :disabled="isDisabled" :maxlength="50" show-word-limit  placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="formProps.gutter">
						<el-col :span="9">
							<el-form-item label="公司概况" prop="simIntro" required>
								<el-input type="textarea" v-model="baseInfo.simIntro" :maxlength="500" show-word-limit :disabled="isDisabled" placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>

			<!-- 内容管理 -->
			<div class="tab-box" v-show="activeTab == 'contentInfo'" v-loading="blockLoading">
				<div
					class="tab-assistant-item mb20"
					v-for="(item, index) in assistantArr"
					:key="'tab' + index"
					:class="{ 'active-item': assistantTab === item.value }"
					@click="assistantClick(item)"
				>
					{{ item.sname }}
				</div>
				<!-- 招标采购tab -->
				<div v-show="assistantTab == 0">
					<div class="top-upload">
						<div class="top-item">
							<div class="top-item-text">页面banner</div>
							<new-upload
								listType="picture-card"
								:aid="pageInfo.id"
								:acceptType="acceptArr"
								tableName="config_topic_page"
								assortment="BID_BANNER"
								width="100%"
								height="120px"
								ref="bidBanner"
								:isDisabled="!isEdit"
								:maxNum="1"
								:uploadText="isEdit ? '上传图片' : '暂无资料'"
							></new-upload>
							<div class="mt5">
								支持图片格式：jpg/jpeg/png，建议上传尺寸：1920*360px
							</div>
						</div>
					</div>
				</div>

				<!-- 关于我们tab -->
				<div v-show="assistantTab == 1">
					<div class="top-upload">
						<div class="top-item">
							<div class="top-item-text">页面banner</div>
							<new-upload
								listType="picture-card"
								:aid="pageInfo.id"
								:acceptType="acceptArr"
								tableName="config_topic_page"
								assortment="ABOUT_INTRO"
								width="100%"
								height="120px"
								ref="aboutBanner"
								:isDisabled="!isEdit"
								:maxNum="1"
								:uploadText="isEdit ? '上传图片' : '暂无资料'"
							></new-upload>
							<div class="mt5">
								支持图片格式：jpg/jpeg/png，建议上传尺寸：1920*360px
							</div>
						</div>
					</div>

					<!-- 企业简介 -->
					<div class="company-profiles">
						<!-- <div class="is-required-item">企业简介</div> -->
						<el-form
							ref="baseForm"
							label-width="120px"
							:model="baseInfo"
							:rules="baseRules"
							:show-message="false"
							:label-position="formProps.labelPosition"
						>
							<el-form-item label="企业简介" prop="aboutIntro" required>
								<wang-editor
									v-model="baseInfo.aboutIntro"
									ref="wangEditor"
									height="100%"
									:isViewMode="!isEdit"
								></wang-editor>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<!-- 联系我们tab -->
				<div v-show="assistantTab == 2">
					<!-- 顶部 upload -->
					<div class="top-upload">
						<div class="top-item">
							<div class="top-item-text">页面banner</div>
							<new-upload
								listType="picture-card"
								:aid="pageInfo.id"
								:acceptType="acceptArr"
								tableName="config_topic_page"
								assortment="CON_BANNER"
								width="100%"
								height="120px"
								ref="conBanner"
								:isDisabled="!isEdit"
								:maxNum="1"
								:uploadText="isEdit ? '上传图片' : '暂无资料'"
							></new-upload>
							<div class="mt5">
								支持图片格式：jpg/jpeg/png，建议上传尺寸：1920*360px
							</div>
						</div>

						<div class="top-item">
							<div class="top-item-text">微信公众号二维码</div>
							<new-upload
								listType="picture-card"
								:aid="pageInfo.id"
								:acceptType="acceptArr"
								tableName="config_topic_page"
								assortment="CON_QR"
								width="50%"
								height="120px"
								ref="conQr"
								:isDisabled="!isEdit"
								:maxNum="1"
								:uploadText="isEdit ? '上传图片' : '暂无资料'"
							></new-upload>
							<div class="mt5">
								支持图片格式：jpg/jpeg/png，建议上传尺寸：148*148px
							</div>
						</div>
					</div>
					<!-- 表单内容 -->

					<el-form
						ref="baseForm"
						label-width="120px"
						:model="baseInfo"
						:rules="baseRules"
						:show-message="false"
						:label-position="formProps.labelPosition"
					>
						<el-row :gutter="formProps.gutter">
							<el-col :span="6">
								<el-form-item label="联系人">
									<el-input
										v-model="baseInfo.conLinker"
										maxlength="30"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="电话">
									<el-input
										v-model="baseInfo.conPhone"
										maxlength="30"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="QQ">
									<el-input
										v-model="baseInfo.conQq"
										maxlength="30"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="邮箱">
									<el-input
										v-model="baseInfo.conEmail"
										maxlength="30"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="formProps.gutter">
							<el-col :span="6">
								<el-form-item label="公司地址" prop="conAddress">
									<el-input
										v-model="baseInfo.conAddress"
										maxlength="200"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="公司官网">
									<el-input
										v-model="baseInfo.conWebsite"
										maxlength="30"
										:disabled="!isEdit"
										placeholder="请输入"
										size="small"
									></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import * as API from 'api/modules/topicPage.js'
import newUpload from '@/components/w-upload/newUpload.vue'

export default {
	components: {
		newUpload
	},
	data() {
		return {
			assistantTab: '0', //
			showMap: false, // 地图弹框显隐
			pageInfo: {}, // 专题页详情
			isEdit: false,
			activeTab: 'baseInfo',
			btnLoading: false,
			blockLoading: false,
			// tab 选项卡
			tabArr: [
				{ label: '基本信息', name: 'baseInfo', type: '1' },
				{ label: '内容管理', name: 'contentInfo', type: '2' }
			],

			// 表单对象
			formProps: {
				gutter: 26,
				labelPosition: 'top',
				uploadWidth: '220px'
			},
			baseInfo: {
				belongCode: '', // 公司信用代码
				homeIntro: '', // 公司名称
				simIntro: '', //概要说明
				aboutIntro: '', // 关于我们-公司简介
				conLinker: '', // 联系人
				conPhone: '', // 联系电话
				conQq: '', // QQ
				conEmail: '', // 邮箱
				conAddress: '', // 公司地址
				conDetailAddr: '', // 公司详细地址
				conWebsite: '', // 公司网址
				homeLogo: '', // 首页企业logo
				homeBanner: '', // 首页banner
				bidBanner: '', // 招标采购banner
				aboutBanner: '', // 关于我们banner
				conBanner: '', // 联系我们banner
				conQr: '' // 联系我们二维码
			},
			baseRules: {
				homeIntro: [{ required: true }], // 公司名称
				simIntro: [{ required: true }], // 概要说明
				aboutIntro: [{ required: true }], // 关于我们-公司简介
				conAddress: [{ required: true }] // 联系人
			},
			acceptArr: ['jpg', 'jpeg', 'png'] // 接受的图片样式
		}
	},
	created() {},

	mounted() {
		if (this.$getSessionItem('pageInfo')) {
			this.pageInfo = JSON.parse(this.$getSessionItem('pageInfo'))
		}
		this.getPageInfo()
	},
	methods: {
		// 选项卡切换
		tabClick(item) {
			this.activeTab = item.name
		},

		// 预览模板
		handlePreview() {
			let url = `${process.env.VUE_APP_PAGE_URL}NgsAzcWeb/#/topicPageManagement/1/${this.baseInfo.belongCode}`
			window.open(url, '_blank')
		},
		/********************   初始化   ********************/
		// 加载数据
		getPageInfo() {
			API.getTopicContent({ id: this.pageInfo.id }).then((res) => {
				console.log(res, 'res')
				let data = Object.assign({}, res.data)
				// 配置信息赋值
				Object.keys(this.baseInfo).forEach((key) => {
					this.baseInfo[key] = data[key]
				})
				// this.$refs.wangEditor.content = data.aboutIntro
			})
		},

		// 内容管理的tab切换
		assistantClick(item) {
			this.assistantTab = item.value
		},

		// 保存
		doSave() {
			let that = this
			that.btnLoading = true
			// 企业LOGOj校验
			if (this.$refs.homeLogo.fileLength == 0) {
				this.$message.warning('请上传企业LOGO！')
				that.btnLoading = false
				return
			} else {
				this.baseInfo.homeLogo = this.$refs.homeLogo.filesList[0].filePath
			}
			this.$refs.baseForm.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.baseInfo)
					params.id = this.pageInfo.id
					// 判断是哪个平台的配置项保存，0是运营中心，1是企业中心
					params.systemId = 0
					that.btnLoading = false

					//  首页banner数据处理
					params.homeBanner = this.$refs.homeBanner.filesList == 0 ? '' : this.$refs.homeBanner.filesList[0].filePath
					//  招标采购banner数据处理
					params.bidBanner = this.$refs.bidBanner.filesList == 0 ? '' : this.$refs.bidBanner.filesList[0].filePath
					// 关于我们banner数据处理
					params.aboutBanner = this.$refs.aboutBanner.filesList == 0 ? '' : this.$refs.aboutBanner.filesList[0].filePath
					// 联系我们banner数据处理
					params.conBanner = this.$refs.conBanner.filesList == 0 ? '' : this.$refs.conBanner.filesList[0].filePath
					// 联系我们二维码数据处理
					params.conQr = this.$refs.conQr.filesList == 0 ? '' : this.$refs.conQr.filesList[0].filePath

					API.saveTopicContent(params).then((res) => {
						// 提示成功
						this.$message.success('保存成功')
						// 获取最新数据
						this.getPageInfo()
						// 状态改为不可修改
						this.isEdit = !this.isEdit
					})
				} else {
					this.$message.warning('请填写所有必填项')
					that.btnLoading = false
				}
			})
		},
	},
	computed: {
		...mapState('app', {
			curTenantId: (state) => state.curTenantId,
			isAdmin: (state) => state.isAdmin
		}),

		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),

		// 是否可编辑
		isDisabled() {
			return !this.isEdit
		},
		assistantArr() {
			let arr = [
				{ value: '0', sname: '招标采购' },
				{ value: '1', sname: '关于我们' },
				{ value: '2', sname: '联系我们' }
			]
			return arr
		}
	}
}
</script>

<style lang="less" scoped>
.tab-main {
	position: relative;
	height: 100%;

	.tab-header {
		height: 64px;
		line-height: 40px;
		background: #ffffff;
		color: #6b6b6b;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		white-space: nowrap;
		border-bottom: 1px solid #2671cc;
		.tab-header-item {
			display: inline-block;
			margin-right: 43px;
			font-size: 14px;
			font-weight: bold;
			cursor: pointer;
		}

		.tab-header-item:last-child {
			margin-right: 69px;
		}

		.tab-header-item.active-item {
			color: #2671cc;
			border-bottom: 3px solid #2671cc;
		}

		.header-btn {
			// width: 88px;
			height: 36px;
			font-size: 14px;
			border-radius: 6px;
		}

		.info-btn {
			background: #ffffff;
			color: #2671cc;
			border: 1px solid #2671cc;
			margin-right: auto;
		}
	}

	.tab-content {
		padding: 20px;
		background-color: #fff;
		border-radius: 12px;
		color: #5e5e5e;
		margin: 10px 0;

		.tab-box {
			width: 100%;
			.tab-assistant-item {
				display: inline-block;
				margin-right: 43px;
				font-size: 14px;
				font-weight: bold;
				cursor: pointer;
			}
			.tab-assistant-item.active-item {
				color: #2671cc;
				//   border-bottom: 3px solid #2671cc;
			}
		}

		.icons-btn {
			width: 36px;
			height: 36px;
			text-align: center;
			padding: 0;
			border-radius: 6px;
			font-size: 14px;
			margin-left: 15px;
		}
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #5e5e5e;
		line-height: 36px;
		padding: 0;
	}
}

// 基本信息
.top-upload {
	height: 180px;
	//   border-bottom: 1px solid #f2f2f2;
	white-space: nowrap;
	margin-bottom: 20px;
	overflow-x: auto;
	overflow-y: hidden;
	/* 解决子元素 inline-block 间距 */
	font-size: 0;

	.top-item {
		font-size: 12px;
		width: 300px;
		margin-right: 36px;
		display: inline-block;
	}

	.top-item-text {
		font-size: 12px;
		line-height: 36px;
		text-align: left;
	}
	.left-item {
		justify-content: flex-start;
	}
}

/* public */
.form-upload {
	height: 130px;
	padding: 5px 20px;
}

.left-width {
	width: 270px;
}

.list-form-upload {
	height: auto;
}

.form-bottom {
	border-bottom: 1px solid #f2f2f2;
	padding-bottom: 20px;
	margin-bottom: 20px;
}

.btn-tools {
	position: absolute;
	right: 20px;
	top: 10px;
	z-index: 10;

	.btn-icons {
		display: block;
		width: 40px;
		line-height: 40px;
		height: 40px;
		text-align: center;
		font-size: 20px;
		color: #fff;
		cursor: pointer;
	}

	.red-bg {
		background-color: #f44336;
	}

	.blue-bg {
		background-color: #2671cc;
	}
}
</style>
